import { render, staticRenderFns } from "./ScriptTaskDetail.vue?vue&type=template&id=5d2d1d24&"
import script from "./ScriptTaskDetail.vue?vue&type=script&lang=js&"
export * from "./ScriptTaskDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports